import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import { useSetNotification } from '../../../context/Notification';
import useRequest from '../../../hooks/useRequest';
import { ExternalUser, UpdateExternalUserParams } from '../types';
import { EXTERNAL_USER_KEY } from './constants';

const useUpdateExternalUser = () => {
    const req = useRequest();
    const setNotification = useSetNotification();
    const queryClient = useQueryClient();

    return useMutation<ExternalUser, { errors: string[] }, UpdateExternalUserParams>({
        mutationFn: ({ id, ...body }) => {
            return req<ExternalUser>({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/external-user/`,
                method: 'PUT',
                body,
                query: { id: String(id) }
            });
        },
        onSuccess: () => {
            setNotification({ message: 'External user updated', icon: 'checkmark' });
            queryClient.invalidateQueries({ queryKey: [EXTERNAL_USER_KEY] });
        }
    });
};

export default useUpdateExternalUser;
